import { render, staticRenderFns } from "./NoMailboxSelected.vue?vue&type=template&id=1cf071d7&scoped=true&"
import script from "./NoMailboxSelected.vue?vue&type=script&lang=js&"
export * from "./NoMailboxSelected.vue?vue&type=script&lang=js&"
import style0 from "./NoMailboxSelected.vue?vue&type=style&index=0&id=1cf071d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf071d7",
  null
  
)

export default component.exports